import { useEffect, useState } from 'react'
import { useGlobalContext } from '../../../../utils/Context'
import PageLoader from '../../../../components/loader/PageLoader'
import { get } from '../../../../utils/Api'
import FormLoader from '../../../../components/loader/FormLoader'
import { Icon } from '@iconify/react'

function Settings() {
  const { profile, fetchUserProfile, profileLoading, notify } =
    useGlobalContext()
  const [edit, setEdit] = useState('')
  useEffect(() => {
    fetchUserProfile()
  }, [])

  //Password Setting
  // const [password, setPassword] = useState({
  //   oldPassword: '********',
  //   newPassword: '',
  //   confirmPassword: '',
  // })
  // const [passwordLoading, setPasswordLoading] = useState(false)

  // async function handlePasswordSubmit() {
  //   setPasswordLoading(true)
  //   if (
  //     !password.oldPassword ||
  //     !password.newPassword ||
  //     !password.confirmPassword
  //   ) {
  //     alert('Please fill in all address fields')
  //     setPasswordLoading(false)
  //     return
  //   }
  //   if (password.newPassword !== password.confirmPassword) {
  //     alert(`Passwords Doesn't match`)
  //     setPasswordLoading(false)
  //     return
  //   }
  //   const res = await put(`user/change-password`, {
  //     oldPassword: password.oldPassword,
  //     newPassword: password.newPassword,
  //   })

  //   if (res.status === 200) {
  //     setPasswordLoading(false)
  //     notify('success', 'Password updated successfully')
  //     fetchUserProfile()
  //     setEdit('')
  //     setPassword({
  //       oldPassword: '********',
  //       newPassword: '',
  //       confirmPassword: '',
  //     })
  //   } else {
  //     notify('error', res.message)
  //   }

  //   setPasswordLoading(false)
  // }

  // Tokens
  const [tokens, setTokens] = useState({
    clientId: '************************',
    production: '************************',
  })
  const [tokenLoading, setTokenLoading] = useState(false)

  const [copied, setCopied] = useState({
    clientId: false,
    production: false,
  })

  function fetchTokens() {
    setTokenLoading(true)
    get('business_admin/tokens/expose')
      .then((result: any) => {
        if (result.status === 200) {
          setTokens({
            clientId: result.data.client_id,
            production: result.data.production_api_key,
          })
          setEdit('tokens')
        } else {
          notify('error', result.message)
        }
        setTokenLoading(false)
      })
      .catch(() => {
        setTokenLoading(false)
      })
  }

  return profileLoading ? (
    <div className='home'>
      <PageLoader position='center' />{' '}
    </div>
  ) : (
    <div className='home bg-white flex justify-center'>
      <div className='settings-wrap'>
        <div className='card-wrap'>
          <h2>Account Settings</h2>
          <div className='flex justify-between flex-wrap'>
            <div className='card'>
              <div className='card-inner'>
                <p>FIRST NAME</p>
                <input type='text' disabled value={profile.firstname} />
              </div>
            </div>
            <div className='card'>
              <div className='card-inner'>
                <p>LAST NAME</p>
                <input type='text' disabled value={profile.lastname} />
              </div>
            </div>
            {/* <div className='card'>
              <div className='card-inner'>
                <p>PHONE NUMBER</p>
                <input type='text' disabled value={profile.phonenumber} />
              </div>
            </div> */}
            <div className='card'>
              <div className='card-inner'>
                <p>EMAIL</p>
                <input
                  type='text'
                  disabled
                  value={profile.email}
                  className='dif'
                />
              </div>
            </div>
          </div>
        </div>
        <div className='card-wrap'>
          <h2>Tokens</h2>
          <div className='flex justify-between flex-wrap'>
            <div className='card dif'>
              <div className='card-inner'>
                <div className='flex items-center'>
                  <p>Client ID</p>
                  <div className='icon'>
                    {edit === 'tokens' && (
                      <Icon
                        icon='charm:clipboard'
                        onClick={() => {
                          navigator.clipboard.writeText(tokens.clientId)
                          setCopied({
                            ...copied,
                            clientId: true,
                          })
                          setTimeout(() => {
                            setCopied({
                              ...copied,
                              clientId: false,
                            })
                          }, 1000)
                        }}
                      />
                    )}
                  </div>
                </div>
                <input type='text' disabled value={tokens.clientId} />
                {copied.clientId && <p>copied</p>}
              </div>
            </div>
            <div className='card dif'>
              <div className='card-inner'>
                <div className='flex'>
                  <p> TOKEN</p>
                  <div className='icon'>
                    {edit === 'tokens' && (
                      <Icon
                        icon='charm:clipboard'
                        onClick={() => {
                          navigator.clipboard.writeText(tokens.production)
                          setCopied({
                            ...copied,
                            production: true,
                          })
                          setTimeout(() => {
                            setCopied({
                              ...copied,
                              production: false,
                            })
                          }, 1000)
                        }}
                      />
                    )}
                  </div>
                </div>
                <input type='text' disabled value={tokens.production} />
                {copied.production && <p>copied</p>}
              </div>
            </div>
          </div>
          {tokenLoading ? (
            <FormLoader position='center' />
          ) : (
            <div className='flex buttons justify-center'>
              <button onClick={() => fetchTokens()}>Reveal</button>
            </div>
          )}
        </div>
        {/* <div className='card-wrap'>
          <h2>Password Settings</h2>
          <div className='flex justify-between flex-wrap'>
            <div className='card'>
              <div className='card-inner'>
                <p>PASSWORD</p>
                <input
                  type='text'
                  disabled={edit !== 'password'}
                  value={password.oldPassword}
                  onChange={(e) =>
                    setPassword({
                      ...password,
                      oldPassword: e.target.value,
                    })
                  }
                />
              </div>
            </div>
            {edit === 'password' && (
              <>
                <div className='card'>
                  <div className='card-inner'>
                    <p>NEW PASSWORD</p>
                    <input
                      type='text'
                      value={password.newPassword}
                      onChange={(e) =>
                        setPassword({
                          ...password,
                          newPassword: e.target.value,
                        })
                      }
                    />
                  </div>
                </div>
                <div className='card'>
                  <div className='card-inner'>
                    <p>Confirm Password</p>
                    <input
                      type='text'
                      value={profile.confirmPassword}
                      onChange={(e) =>
                        setPassword({
                          ...password,
                          confirmPassword: e.target.value,
                        })
                      }
                    />
                  </div>
                </div>
              </>
            )}
          </div>
          {passwordLoading ? (
            <FormLoader position='center' />
          ) : (
            <>
              {edit === 'password' ? (
                <div className='flex buttons justify-center'>
                  <button
                    className='cancel'
                    onClick={() => {
                      setEdit('')
                      setPassword({
                        ...password,
                        oldPassword: '********',
                      })
                    }}
                  >
                    Cancel
                  </button>
                  <button onClick={() => handlePasswordSubmit()}>Save</button>
                </div>
              ) : (
                <div className='flex buttons justify-center'>
                  <button
                    onClick={() => {
                      setEdit('password')
                      setPassword({
                        ...password,
                        oldPassword: '',
                      })
                    }}
                  >
                    Change Password
                  </button>
                </div>
              )}
            </>
          )}
        </div> */}
      </div>
    </div>
  )
}

export default Settings
